import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setOverdueTreatmentCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getOverdueTreatmentCount() {
            return HTTP.get('/kenya/treatment-overdue/count');
        }
    },
}